import { createSelector } from 'reselect';
import { selectJwt }      from '../modules/auth/selectors/authSelectors';


export const selectJwtIfNotExpired = createSelector(
  selectJwt,
  (jwt) => {

    if (
      !jwt
      || !jwt.hasIn(['payload', 'exp'])
      || !(new Date(jwt.getIn(['payload', 'exp'])) > new Date())
    ) {

      return null;

    }

    return jwt;

  }
);


export const selectIsLoggedIn = createSelector(
  selectJwtIfNotExpired,
  (jwt) => Boolean(jwt),
);


export const selectJwtTokenStringIfNotExpired = createSelector(
  selectJwtIfNotExpired,
  (jwt) => (jwt && jwt.getIn(['token'])) || null,
);


export const selectJwtUserIdIfNotExpired = createSelector(
  selectJwtIfNotExpired,
  (jwt) => (jwt && jwt.getIn(['userId'])) || null,
);


// WEBPACK FOOTER //
// ./src/selectors/auth.js